import type { FC } from "react";

import clsx from "clsx";

import type { FieldOptionModel } from "../Fields/FieldOption";

export interface OptionComponentProps {
	option: Partial<FieldOptionModel>;
	idx: number;
}

interface SelectProps {
	options: Partial<FieldOptionModel>[];
	optionComponent: ({ option, idx }: OptionComponentProps) => JSX.Element;
	addMore?: JSX.Element;
	wrapperClassName?: string;
	noWrap?: boolean;
}

const SelectBase: FC<SelectProps> = ({ options, optionComponent, addMore, wrapperClassName, noWrap }) => (
	<div className={clsx("flex items-center gap-1", !noWrap && "flex-wrap", wrapperClassName)}>
		{options.map((opt, i) =>
			opt.deleted ? null : (
				<div key={i}>
					{optionComponent({
						option: opt,
						idx: i
					})}
				</div>
			)
		)}
		{addMore}
	</div>
);

export default SelectBase;
